import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, errText } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { checkAuth: refresh } = useAuth();
  const { t } = useLanguage();
  const [state, setState] = useState({ status: "loading" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) return setState({ status: "error", msg: t("ce_missing") });
    api.post("/auth/email-change/confirm", { token })
      .then((r) => { setState({ status: "ok", email: r.data.email }); refresh?.(); })
      .catch((e) => setState({ status: "error", msg: errText(e) }));
  }, [token, refresh, t]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="confirm-email-page">
      <div className="max-w-md w-full bg-white rounded-2xl border border-slate-200 p-8 text-center">
        {state.status === "loading" && <Loader2 size={32} className="animate-spin text-[#F5551E] mx-auto" />}
        {state.status === "ok" && (
          <>
            <CheckCircle2 size={44} className="text-emerald-600 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-[#12234A] mt-3">{t("ce_ok_title")}</h1>
            <p className="text-slate-500 mt-2" data-testid="confirm-email-success">{t("ce_ok_body")} <b>{state.email}</b>. {t("ce_ok_body2")}</p>
            <Link to="/dashboard?tab=profile" className="inline-block mt-5 text-[#F5551E] font-semibold" data-testid="confirm-email-dashboard">{t("ce_profile")}</Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle size={44} className="text-red-500 mx-auto" />
            <h1 className="font-display text-2xl font-bold text-[#12234A] mt-3">{t("ce_err_title")}</h1>
            <p className="text-slate-500 mt-2" data-testid="confirm-email-error">{state.msg}</p>
            <Link to="/dashboard?tab=profile" className="inline-block mt-5 text-[#F5551E] font-semibold">{t("ce_profile")}</Link>
          </>
        )}
      </div>
    </div>
  );
}
